import { motion } from "framer-motion";

export const LogoMark = ({ className = "w-8 h-8", animate = false }) => {
  const draw = animate
    ? { initial: { pathLength: 0, opacity: 0 }, animate: { pathLength: 1, opacity: 1 }, transition: { duration: 1.6, ease: [0.16, 1, 0.3, 1] } }
    : {};
  return (
    <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="redoc-g" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#19C3CF" />
          <stop offset="1" stopColor="#4B5FD1" />
        </linearGradient>
      </defs>
      <g stroke="url(#redoc-g)" strokeWidth="4" strokeLinecap="round">
        <motion.circle cx="34" cy="10" r="6" {...draw} />
        <motion.circle cx="12" cy="24" r="6" {...draw} />
        <motion.circle cx="34" cy="38" r="6" {...draw} />
        <motion.path d="M17.3 21 28.7 13M17.3 27 28.7 35" {...draw} />
      </g>
    </svg>
  );
};

export const LogoLight = ({ className = "h-8" }) => (
  <img src="/redoc-logo.png" alt="Redoc" className={`${className} w-auto`} />
);

export const LogoDark = () => (
  <span className="inline-flex items-center gap-2">
    <LogoMark className="w-9 h-9" />
    <span className="text-3xl font-semibold tracking-tight text-white">Redoc</span>
  </span>
);
